import { render } from "./CarouselPropsCmp.vue?vue&type=template&id=79061272"
import script from "./CarouselPropsCmp.vue?vue&type=script&lang=js"
export * from "./CarouselPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__